export interface SourceFrameBlend {
  frameIndex: number;
  nextFrameIndex: number;
  mix: number;
}

/** Resample an archived movie at the display clock without changing its rate.
 * Exact source ticks retain the original frame, including repeats and blanks.
 * A one-shot's last frame is held; only a looping movie wraps to its first.
 */
export function sourceFrameBlend(elapsedMs: number, frameRate: number, frameCount: number, loop = false): SourceFrameBlend {
  const count = Number.isFinite(frameCount) ? Math.max(1, Math.floor(frameCount)) : 1;
  const rate = Number.isFinite(frameRate) && frameRate > 0 ? frameRate : 25;
  const elapsed = Number.isFinite(elapsedMs) ? Math.max(0, elapsedMs) : 0;
  const position = elapsed * rate / 1000;
  const tick = Math.floor(position);
  const frameIndex = loop ? tick % count : Math.min(tick, count - 1);
  const nextFrameIndex = loop ? (frameIndex + 1) % count : Math.min(frameIndex + 1, count - 1);
  return { frameIndex, nextFrameIndex, mix: frameIndex === nextFrameIndex ? 0 : position - tick };
}
